import { get, trim } from 'lodash';
import Vue from 'vue';
import { LOCALE } from '../../config';

export function acl(key: string) {
  return get(LOCALE, trim(key).toUpperCase());
}

Vue.filter('acl', acl);
